import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import * as api from '../../../api/educentialApi';

// Import overseas service pages
import UKPathfinder from '../../overseas/UK/Pathfinder';
import FinancialAnalysis from '../../overseas/UK/FinancialAnalysis';
import UKReadinessAssessment from '../../overseas/UK/ReadinessAssessment';
import OverseasDashboard from './OverseasDashboard';
import OverseasApplicationTracker from './OverseasApplicationTracker';

/**
 * OverseasServiceRoutes - Routing wrapper for Overseas Education service
 * 
 * This component:
 * 1. Checks if user is enrolled in overseas service
 * 2. Auto-enrolls if not enrolled
 * 3. Routes to overseas service pages
 */
const OverseasServiceRoutes = () => {
  const [loading, setLoading] = useState(true);
  const [enrolled, setEnrolled] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    checkEnrollment();
  }, []);

  const checkEnrollment = async () => {
    try {
      setLoading(true);
      const response = await api.getServiceStatus('overseas');
      
      if (response.data.enrolled) {
        setEnrolled(true);
      } else {
        // Auto-enroll user
        await api.enrollInService('overseas');
        setEnrolled(true);
      }
    } catch (err) {
      console.error('Error checking enrollment:', err);
      setError('Failed to access service. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading Overseas Education service...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
          <h2 className="text-lg font-semibold text-red-900 mb-2">Error</h2>
          <p className="text-red-800 mb-4">{error}</p>
          <button
            onClick={() => navigate('/services')}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Back to Services
          </button>
        </div>
      </div>
    );
  }

  if (!enrolled) {
    return <Navigate to="/services" replace />;
  }

  return (
    <Routes>
      <Route index element={<OverseasDashboard />} />
      <Route path="application-tracker" element={<OverseasApplicationTracker />} />
      <Route path="uk/pathfinder" element={<UKPathfinder />} />
      <Route path="uk/financial-analysis" element={<FinancialAnalysis />} />
      <Route path="uk/readiness-assessment" element={<UKReadinessAssessment />} />
      {/* Add more country-specific routes here */}
      <Route path="*" element={<Navigate to="/services/overseas" replace />} />
    </Routes>
  );
};

export default OverseasServiceRoutes;
